// src/pages/Home.jsx
import React from 'react';
import { Box } from '@mui/material';
import Hero from '../components/Homepage/Hero';
import QuickLinksSection from '../components/QuickLinks/QuickLinksSection';
import NewsletterAndNews from '../components/News/NewsletterAndNews';
import SupportSection from '../components/Homepage/SupportSection';

export default function Home() {
    return (
        <Box component="main">
            <Hero
                height="45vh" // Desktop/tablet preserved; phones get smart height from the component
                title="Welcome to the Piedmont, Alabama Historical Society"
                subtitle="Southern Railroad Depot Museum"
                intro={
                    <>
                        Located in the beautifully restored Piedmont Depot, our museum brings Alabama’s
                        story to life with interactive exhibits, local archival treasures, and guided tours.
                    </>
                }
            />

            <QuickLinksSection />
            <NewsletterAndNews />
            <SupportSection />
        </Box>
    );
}
